<template>
  <sf-info-dialog :title="$t('price.graduatedPrices')">
    <template #activator="{ props }">
      <sf-text-button v-bind="props">
        <v-icon start :icon="mdiElevationDecline" />
        {{ $t('price.graduatedPrices') }}
      </sf-text-button>
    </template>
    <template #content>
      <div
        v-for="(supplier, index) in suppliersWithScales"
        :key="supplier.id"
        :class="{ 'mb-2': index != suppliersWithScales.length - 1 }"
      >
        <div class="d-flex justify-space-between flex-gap">
          <sf-sub-heading>
            {{ supplier.supplierName }}
          </sf-sub-heading>
          <sf-color-text v-if="supplier.stock" :color="getStockStatusColor(supplier.stock.status)">
            {{ supplier.stock.count > 0 ? supplier.stock.count : '' }}
            {{ $t('stockStatus.' + supplier.stock.status) }}
          </sf-color-text>
        </div>
        <div
          v-for="scale in supplier.scales"
          :key="scale.minScale"
          class="d-flex justify-space-between flex-gap"
        >
          <sf-text>
            {{ $t('price.startingAt', [scale.minScale]) }}
          </sf-text>
          <sf-text>{{ formatMoney(scale.resellPrice, true) }}</sf-text>
        </div>
      </div>
    </template>
  </sf-info-dialog>
</template>

<script setup lang="ts">
import SfTextButton from '@/components/button/SfTextButton.vue'
import SfInfoDialog from '@/components/dialog/SfInfoDialog.vue'
import SfColorText from '@/components/text/SfColorText.vue'
import SfSubHeading from '@/components/text/SfSubHeading.vue'
import SfText from '@/components/text/SfText.vue'
import { formatMoney, getStockStatusColor } from '@/modules/product/helpers'
import { SupplierRow } from '@/types/index'
import { mdiElevationDecline } from '@mdi/js'
import { computed, PropType } from 'vue'

const componentProps = defineProps({
  suppliers: {
    type: Array as PropType<SupplierRow[]>,
    required: true
  }
})

const suppliersWithScales = computed(() => {
  return componentProps.suppliers.filter((supplier) => supplier.scales.length > 0)
})
</script>
